// Going into a customer's account during onboarding, and coming back out
// (backend/support_access.py). While inside, this browser is signed in as
// the customer; the admin's own token waits in localStorage under ADMIN_KEY
// for the way back.
import { supportApi } from './support';
import { useAuthStore } from '../store/authStore';
import { useAppStore } from '../store/appStore';

const ADMIN_KEY = 'nhd_admin_session';
const THREAD_KEY = 'nhd_support_thread';

/** Whether this browser holds an admin's token while in a customer's account. */
export function inCustomerAccount() {
  try {
    return !!localStorage.getItem(ADMIN_KEY);
  } catch {
    return false;
  }
}

// One account's cached data must never show in the other's
function switchTo(token, path) {
  useAppStore.getState().clearAllData?.();
  useAuthStore.getState().setSessionToken(token);
  if (token) localStorage.setItem('session_token', token);
  else localStorage.removeItem('session_token');
  window.location.assign(path);
}

/** Open the customer's account from their onboarding conversation. */
export async function enterCustomerAccount(threadId) {
  const adminToken = useAuthStore.getState().sessionToken || localStorage.getItem('session_token');
  const { session_token: token } = await supportApi.openAccount(threadId);
  localStorage.setItem(ADMIN_KEY, adminToken);
  localStorage.setItem(THREAD_KEY, threadId);
  switchTo(token, '/equipment');
}

/** Leave the customer's account and go back to their conversation in Support. */
export async function leaveCustomerAccount() {
  const threadId = localStorage.getItem(THREAD_KEY);
  let adminToken = localStorage.getItem(ADMIN_KEY);
  try {
    const result = await supportApi.endAccess();
    adminToken = result.session_token || adminToken;
  } catch {
    // The session has already ended (it lasts an hour): just go back
  }
  localStorage.removeItem(ADMIN_KEY);
  localStorage.removeItem(THREAD_KEY);
  switchTo(adminToken, threadId ? `/support/${threadId}` : '/support');
}
